export default __webpack_public_path__ + "static/media/brand-box.3b0fbe25.svg";